import _ from 'lodash';
import imagemap from '../resources/imagemap.json';
import systems_imagemap from '../resources/systems_imagemap.json';

const ENDPOINT_IMAGE_MAP = imagemap ? mapKeysToLowerCase(imagemap) : {};
const ENDPOINT_BASE_DIR = ENDPOINT_IMAGE_MAP['basepath'] || 'dist/images/endpoints/';
const ENDPOINT_DEFAULT_IMG = ENDPOINT_IMAGE_MAP['default'] || 'NoImage.svg';

const SYSTEM_IMAGE_MAP = systems_imagemap ? mapKeysToLowerCase(systems_imagemap) : {};
const SYSTEM_BASE_DIR = SYSTEM_IMAGE_MAP['basepath'] || 'dist/images/systems/';
const SYSTEM_DEFAULT_IMG = SYSTEM_IMAGE_MAP['default'] || '40x40-unknown.png';


function mapKeysToLowerCase(map) {
    return _.mapKeys(map, function(val, key) {
        return key.toLowerCase();
    })
}

export default {
    getImageUrl: function(mod, manuf) {
        if (Object.keys(ENDPOINT_IMAGE_MAP).length === 0 || !mod) {
            return ENDPOINT_BASE_DIR + ENDPOINT_DEFAULT_IMG;
        }

        let model = mod.toLowerCase();
        let manufacturer = manuf ? manuf.toLowerCase() : '';

        if (ENDPOINT_IMAGE_MAP[model]) { return ENDPOINT_BASE_DIR + ENDPOINT_IMAGE_MAP[model]; }
        // If we have an exact match in the imageMap, use the exact match.
        // Otherwise, try to parse off any common manufacturer prefix

        if (_.startsWith(model, 'spark ') || _.startsWith(model, 'webex ') || _.startsWith(model, 'cisco ')) { // all of these are the same number of characters
            model = model.slice(0, 6); // 'cisco '.length is 6
        } else if (_.startsWith(model, 'polycom ')) {
            model = model.slice(0, 8); // 'polycom '.length is 8
        } else if (_.startsWith(model, 'tandberg ')) {
            model = model.slice(0, 9); // 'tanberg '.length is 9
        }

        if (ENDPOINT_IMAGE_MAP[model]) { return ENDPOINT_BASE_DIR + ENDPOINT_IMAGE_MAP[model]; }

        // if we still don't have an image, try to use the manufacturer name
        if (manufacturer && ENDPOINT_IMAGE_MAP[manufacturer]) {
            return ENDPOINT_BASE_DIR + ENDPOINT_IMAGE_MAP[manufacturer];
        }

        return ENDPOINT_BASE_DIR + ENDPOINT_DEFAULT_IMG;
    },

    getSystemImageUrl: function(mod) {
        if (Object.keys(SYSTEM_IMAGE_MAP).length === 0 || !mod) {
            return SYSTEM_BASE_DIR + SYSTEM_DEFAULT_IMG;
        }

        let model = mod.toLowerCase();

        if (SYSTEM_IMAGE_MAP[model]) { return SYSTEM_BASE_DIR + SYSTEM_IMAGE_MAP[model]; }


        return SYSTEM_BASE_DIR + SYSTEM_DEFAULT_IMG;
    }
}
